
import {ExTranslationGetInfo} from "./ExTranslation"
import {ExGenderGetInfo} from "./ExGender";
import {ExSpellingGetInfo} from "./ExSpelling"

const exElementGetInfoList = {
       ExSpellingGetInfo,
        ExQCMGetInfo: ExGenderGetInfo,
        ExTranslationGetInfo
};

export const getExElementGetInfoFunctionList = () => {
    return exElementGetInfoList;
}

